import { useAuthStore } from '@/stores/authStore';
import type { UserResponse } from '@/types/auth.types';

export const useAuthReady = (): {
  isReady: boolean;
  companyId: number | null;
  user: UserResponse | null;
} => {
  const { company, user, isRestored } = useAuthStore();

  return {
    isReady: isRestored,
    companyId: company?.id || null,
    user: user,
  };
};